export * from './notification-preference-my-suffix-update.component';
export * from './notification-preference.service';
export * from './notification-preference.route';
export * from './notification-preference-my-suffix-detail.component';
